import React, { useEffect, useState } from "react";
import styles from "./myAccount.module.css";
import FormFields from "../../components/Form";
import { useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Toast, { allowOnlyAlphaAndSpace } from "utils";
import Button from "common/Button";
import { getData, updateData } from "utils/queries";

const MyAccount = () => {
  const navigate = useNavigate();

  const [myAccount, setMyAccountDetails] = useState({
    first_name: "",
    last_name: "",
    email:"",
    phone_no:"",
    is_notifications_enabled:false
  });



  const handleGetUserData = async (e,type)=>{
    e?.preventDefault();
     try {

      const response = await getData("auth")
      if (response?.data?.success) {
        // Toast().Success(response?.data?.message);
        setMyAccountDetails(response?.data?.data)
      }
    } catch (error) {
      // Toast().Error(
      //   error?.response?.data?.message ||
      //     error?.response?.data?.errors?.[0]?.msg
      // );
    }
 
  } 

  useEffect(()=>{
    console.log("triggering")
    handleGetUserData()
  },[])


  const handleMyAccountChange = (label,parseFunc) => {
  
    return (e) => {
      let value = e.target.value;
      if(parseFunc){
        value= parseFunc(value)
      }

      if(["first_name", "last_name"]?.includes(label)){
        e.target.value = allowOnlyAlphaAndSpace(e)
      }
      setMyAccountDetails({ ...myAccount, [label]: e.target.value });
    };
  };

  const handleNotificationChange = (label) => {
    return (e) => {
      setMyAccountDetails({ ...myAccount, [label]: e?.target?.checked });
    };
  };
  const MyAccountFields = [
    {
      label: "First Name",
      id: "firstName",
      placeholder: "Enter Name",
      type: "text",
      value: myAccount?.first_name,
      required: true,
      onChange: handleMyAccountChange("first_name"),
    },
    {
      label: "Last Name",
      id: "last_name",
      placeholder: "Last Name",
      type: "text",
      value: myAccount?.last_name,
      required: true,
      onChange: handleMyAccountChange("last_name"),
    },
    {
      label: "Email",
      id: "email",
      placeholder: "Enter Email",
      type: "email",
      value: myAccount?.email,
      disabled:true,
      required: true,
      onChange: handleMyAccountChange("email"),
    },
    {
      label: "Mobile Phone",
      id: "phone",
      // placeholder: "44 7293089739",
      type: "number",
      value: myAccount?.phone_no,
      required: false,
      onChange: handleMyAccountChange("phone_no"),
    },
  ];

  const NotificationFields = [
    {
      label: "Enable Email Notifications",
      id: "enableEmailNotifications",
      // placeholder: "Enter Name",
      type: "checkbox",
      checked: myAccount?.is_notifications_enabled,
      // required: true,
      onChange: handleNotificationChange("is_notifications_enabled"),
    },
  ];

  const handleSave = async (e) => {
    e.preventDefault();
    try {

      const response = await updateData("auth",{...myAccount})
      // if (response?.data?.success) {
      //   Toast().Success(response?.data?.message);
      // }
    } catch (error) {
      // Toast().Error(
      //   error?.response?.data?.message ||
      //     error?.response?.data?.errors?.[0]?.msg
      // );
    }
  };

  return (
    <div className={styles.container}>
      <Tabs>
        <TabList>
          <Tab>My Account</Tab>
          <Tab>Notifications</Tab>
        </TabList>
        <TabPanel>
          <div className={styles.formContainer}>
            {/* {error && <p className={styles.error}>{error}</p>} */}
            <form onSubmit={handleSave}>
              <FormFields Fields={MyAccountFields} />
              <div className={styles.formGroup}>
                <Button label={"Save"} type="submit" buttonOverrideStyle={styles.button_}>
                </Button>
              </div>
            </form>
            <div className={styles?.divider}></div>
            <div className={styles.account}>
              <div className={styles.changePassword}
               onClick={()=>navigate("/forgot-password")}
              >Change Password</div>
              <div
                className={styles.deleteButton}
                onClick={() => navigate("/")}
              >
                Delete my account
              </div>
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div className={styles.formContainer}>
            <form onSubmit={handleSave}>
              <div className={styles.notificationsLabel}>
                Email Notifications
              </div>
              <FormFields Fields={NotificationFields} />
              <div className={styles?.divider}></div>
              <div className={styles.notificationSaveButton_Container}>
                <Button
                label={"Save"}
                  type="submit"
                  buttonOverrideStyle={styles.notificationSaveButton_}
                >
                </Button>
              </div>
            </form>
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default MyAccount;
